<!--订单信息-->
<template>
  <div class="table-container">
    <vxe-table :data="data" align="center" :header-cell-style="{backgroundColor: '#F0F6FD',color: '#333333'}">
      <vxe-column field="goodsName" title="商品名称" align="left">
        <template #default="{row,rowIndex,column}">
          <div class="goodsInfo">
            <el-image style="width: 75px; height: 75px" :src="row.goodsImage" fit="contain"></el-image>
            <p>
              <span class="SourceHanSansCN">{{ row.goodsName }}</span><br/>
              <span class="address">{{ row.handlingAreaId }}</span>
            </p>
          </div>
        </template>
      </vxe-column>
      <vxe-column field="price" title="单价" width="150">
        <template #default="{row,rowIndex,column}">
          <span class="Medium">￥{{ parseFloat(row.price).toFixed(2) }}</span>
        </template>
      </vxe-column>
      <vxe-column field="amount" title="数量" width="90">
        <template #default="{row,rowIndex,column}">
          <span class="Medium">{{ row.amount }}</span>
        </template>
      </vxe-column>
      <vxe-column field="preferentialAmount" title="优惠" width="150">
        <template #default="{row,rowIndex,column}">
          <span class="Medium"
                v-if="row.preferentialAmount>0">-￥{{ parseFloat(row.preferentialAmount).toFixed(2) }}</span>
        </template>
      </vxe-column>
      <vxe-column field="total" title="实付金额" width="150" :visible="type==0 ? true : false">
        <template #default="{row,rowIndex,column}">
          <span class="Medium">￥{{ parseFloat(row.price).toFixed(2) }}</span>
        </template>
      </vxe-column>
      <vxe-column field="state" title="订单状态" width="150" v-if="type==1">
        <template #default="{row,rowIndex,column}">
          <span class="Medium" v-if="row.state == 0">待付款</span>
          <span class="Medium" v-else-if="row.state == 1">进行中</span>
          <span class="Medium" v-else-if="row.state == 2">待评价</span>
          <span class="Medium" v-else-if="row.state == 3">已完成</span>
          <span class="Medium" v-else-if="row.state == 6">服务中</span>
          <span class="Medium" v-else-if="row.state == -2">退款中</span>
          <span class="Medium" v-else-if="row.state == -3">退款成功</span>
          <span class="Medium" v-else-if="row.state == -4">退款失败</span>
          <span class="Medium" v-else-if="row.state == 5">交易关闭</span>
        </template>
      </vxe-column>
    </vxe-table>
  </div>
</template>
<script>
import Vue from 'vue';
import VXETable from 'vxe-table';
import 'vxe-table/lib/index.css';

Vue.use(VXETable)
export default {
  name: "refundProcess",
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    state: {
      type: Number,
      default() {
        return 0
      }
    },
    type: {
      type: Number,
      default() {
        return 0
      }
    },
  },
}
</script>

<style scoped lang="scss">
.table-container {
  .goodsInfo {
    display: flex;

    p {
      padding-left: 15px;
      color: #333333;
      margin-block-end: 0px;
      margin-block-start: 0px;

      .address {
        position: absolute;
        bottom: 10px;
        color: #999999;
        font-size: 14px;
      }
    }
  }

  .Medium {
    font-family: 'SourceHanSansCN';
    color: #333333;
  }
}
</style>